import { create } from "zustand";
import type { Form, FormState } from "../types";
import { formApi } from "../services/form-api";

export const useFormStore = create<FormState>((set) => ({
	forms: null,
	presets: null,

	index: async (workspaceId: string) => {
		const response = await formApi.index(workspaceId);

		if (response.success && response.data) {
			set({ forms: response.data });
		}

		return response;
	},

	show: async (id: string, workspaceId: string) => {
		const response = await formApi.show(id, workspaceId);

		return response;
	},

	create: async (workspaceId: string, payload) => {
		const response = await formApi.create(workspaceId, payload);

		if (response.success && response.data) {
			set((state) => ({
				forms: state.forms && response.data ? [...state.forms, response.data] : response.data ? [response.data] : state.forms ?? [],
			}));
		}

		return response;
	},

	update: async (id: string, workspaceId: string, payload) => {
		const response = await formApi.update(id, workspaceId, payload);

		if (response.success && response.data) {
			set((state) => ({
				forms: state.forms ? state.forms.map((form) => (form.id === id ? response.data : form)).filter((form): form is Form => form !== null && form !== undefined) : [],
			}));
		}

		return response;
	},

	delete: async (id: string, workspaceId: string) => {
		const response = await formApi.delete(id, workspaceId);

		if (response.success) {
			set((state) => ({
				forms: (state.forms ?? []).filter((form) => form.id !== id),
			}));
		}

		return response;
	},

	clone: async (id: string, workspaceId: string) => {
		const response = await formApi.clone(id, workspaceId);

		if (response.success && response.data) {
			set((state) => ({
				forms: state.forms && response.data ? [...state.forms, response.data] : response.data ? [response.data] : state.forms ?? [],
			}));
		}

		return response;
	},

	listPresets: async () => {
		const response = await formApi.listPresets();

		if (response.success && response.data) {
			set({ presets: response.data });
		}

		return response;
	},
}));
